import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
// import { TourNgBootstrapModule } from 'ngx-tour-ng-bootstrap';

import { DemoMaterialModule } from './material-demo.module';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core';
import 'hammerjs';

import { SilkAppComponent } from './app.component';
import { AppRoutes } from "./app-routing.module";
import { MenuToggleModule } from './core/menu/menu-toggle.module';
import { MenuItems } from './core/menu/menu-items/menu-items';
import { HorizontalMenuItems } from './core/menu/menu-items/horizontal-menu-items';
import { PageTitleService } from './core/page-title/page-title.service';
import { DashboardComponent } from './components/hrwe-tpl/dashboard/dashboard.component';
import { LoginComponent } from './components/hrwe-tpl/login/login.component';
import { RegistrationEmailConfirmComponent } from './components/hrwe-tpl/registration/registration-email-confirm/registration-email-confirm.component';
import { RegistrationComponent } from './components/hrwe-tpl/registration/registration/registration.component';
import { PersonalDetailComponent } from './components/hrwe-tpl/registration/personalDetail/personalDetail.component';
import { CompanyDetailComponent } from './components/hrwe-tpl/registration/companyDetail/companyDetail.component';
import { SummaryComponent } from './components/hrwe-tpl/registration/summary/summary.component';
import { UserListComponent } from './components/hrwe-tpl/user/user-list/user-list.component';
import { UserDetailComponent } from './components/hrwe-tpl/user/user-detail/user-detail.component';
import { ContractSignIntroductionComponent } from './components/hrwe-tpl/registration/contract-sign/contract-sign-introduction/contract-sign-introduction.component';
import { ContractSignSigningProcessComponent } from './components/hrwe-tpl/registration/contract-sign/contract-sign-signing-process/contract-sign-signing-process.component';
import { ContractSignSuccessComponent } from './components/hrwe-tpl/registration/contract-sign/contract-sign-success/contract-sign-success.component';
import { DashboardLayoutComponent } from './components/hrwe-tpl/dashboard-layout/dashboard-layout.component';
import { RegisterLayoutComponent } from './components/hrwe-tpl/register-layout/register-layout.component';
import { HeaderComponent } from './components/hrwe-tpl/register-layout/header/header.component';
import { FooterComponent } from './components/hrwe-tpl/register-layout/footer/footer.component';
import { ProfilePersonalComponent } from './components/hrwe-tpl/profile/profile-personal/profile-personal.component';
import { ProfileCompanyComponent } from './components/hrwe-tpl/profile/profile-company/profile-company.component';
import { ProfileContractComponent } from './components/hrwe-tpl/profile/profile-contract/profile-contract.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BlankComponent } from './custom-pages/blank/blank.component';
import { NewReportRequestComponent } from './components/hrwe-tpl/report/new-report-request/new-report-request.component';
import { NewReportListComponent } from './components/hrwe-tpl/report/new-report-list/new-report-list.component';
import { NewReportDetailComponent } from './components/hrwe-tpl/report/new-report-detail/new-report-detail.component';
import { CandidateEntryComponent } from './components/hrwe-tpl/report/candidate-entry/candidate-entry.component';
import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import { CreateConfigComponent } from './components/hrwe-tpl/config/create-config/create-config.component';
import { ManageConfigComponent } from './components/hrwe-tpl/config/manage-config/manage-config.component';
import { ListConfigComponent } from './components/hrwe-tpl/config/list-config/list-config.component';
import { ResetPasswordComponent } from './components/hrwe-tpl/reset-password/reset-password.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSpinnerOverlayComponent } from './components/hrwe-tpl/spinner/mat-spinner-overlay.component';
import { CandidateListComponent } from './components/hrwe-tpl/report/candidate-list/candidate-list.component';
import { CreateAssistenzaComponent } from './components/hrwe-tpl/assistenza/create-assistenza/create-assistenza.component';
import { ListAssistenzaComponent } from './components/hrwe-tpl/assistenza/list-assistenza/list-assistenza.component';
import { ManageAssistenzaComponent } from './components/hrwe-tpl/assistenza/manage-assistenza/manage-assistenza.component';
import { ListDocumentComponent } from './components/hrwe-tpl/document/list-document/list-document.component';
import { CreateDocumentComponent } from './components/hrwe-tpl/document/create-document/create-document.component';
import { ManageDocumentComponent } from './components/hrwe-tpl/document/manage-document/manage-document.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ListRegisterPaymentComponent } from './components/hrwe-tpl/payment/list-register-payment/list-register-payment.component';
import { ListBillPaymentComponent } from './components/hrwe-tpl/payment/list-bill-payment/list-bill-payment.component';
import { BillDetailComponent } from './components/hrwe-tpl/payment/bill-detail/bill-detail.component';
import localeIt from '@angular/common/locales/it';
import { AdminDetailComponent } from './components/hrwe-tpl/profile/admin-detail/admin-detail.component';
import { CandidateDetailComponent } from './components/hrwe-tpl/report/candidate-detail/candidate-detail.component';
import { CandidatePrivacyComponent } from './components/hrwe-tpl/report/candidate-privacy/candidate-privacy.component';
import { CandidateSuccessComponent } from './components/hrwe-tpl/report/candidate-success/candidate-success.component';
import { ChartsModule } from 'ng2-charts';
import { GaugeChartModule } from 'angular-gauge-chart';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NewVisuraRequestComponent } from './components/hrwe-tpl/report/new-visura-request/new-visura-request.component';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};

registerLocaleData(localeIt, 'it');

@NgModule({
    imports: [
        NgxDatatableModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        DemoMaterialModule,
        RouterModule.forRoot(AppRoutes, { relativeLinkResolution: 'legacy' }),
        PerfectScrollbarModule,
        MenuToggleModule,
        HttpClientModule,
        MatProgressSpinnerModule,
        // TourNgBootstrapModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient],
            },
            defaultLanguage: 'it',
            useDefaultLang: true
        }),
        NgxChartsModule,
        ChartsModule,
        GaugeChartModule,
        NgbModule

    ],
    declarations: [
        SilkAppComponent,
        HeaderComponent,
        FooterComponent,
        RegisterLayoutComponent,
        DashboardLayoutComponent,
        LoginComponent,
        ResetPasswordComponent,
        RegistrationComponent,
        DashboardComponent,
        RegistrationEmailConfirmComponent,
        PersonalDetailComponent,
        CompanyDetailComponent,
        SummaryComponent,
        UserListComponent,
        UserDetailComponent,
        ContractSignIntroductionComponent,
        ContractSignSigningProcessComponent,
        ContractSignSuccessComponent,
        ProfilePersonalComponent,
        ProfileCompanyComponent,
        ProfileContractComponent,
        BlankComponent,
        NewVisuraRequestComponent,
        NewReportRequestComponent,
        NewReportListComponent,
        NewReportDetailComponent,
        CandidateEntryComponent,
        CreateConfigComponent,
        ManageConfigComponent,
        ListConfigComponent,
        MatSpinnerOverlayComponent,
        CandidateListComponent,
        CreateAssistenzaComponent,
        ListAssistenzaComponent,
        ManageAssistenzaComponent,
        ListDocumentComponent,
        CreateDocumentComponent,
        ManageDocumentComponent,
        ListRegisterPaymentComponent,
        ListBillPaymentComponent,
        BillDetailComponent,
        AdminDetailComponent,
        CandidateDetailComponent,
        CandidatePrivacyComponent,
        CandidateSuccessComponent
    ],
    bootstrap: [SilkAppComponent],
    providers: [
        MenuItems,
        HorizontalMenuItems,
        TranslateService,
        PageTitleService,
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        DatePipe,
        CurrencyPipe,
        {
            provide: LOCALE_ID,
            useValue: "it"
        }
    ]
})
export class SilkAppModule { }
